import toast from "react-hot-toast";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewBuilderResaleList = (builderResaleData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_BUILDER_RESALE_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/builder-resale/list`,
        builderResaleData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_BUILDER_RESALE_LIST_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "GET_BUILDER_RESALE_LIST_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "GET_BUILDER_RESALE_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewBuilderResale = (builderResaleData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_BUILDER_RESALE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/builder-resale/view`,
        builderResaleData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_BUILDER_RESALE_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "GET_BUILDER_RESALE_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "GET_BUILDER_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewBuilderResale = (builderResaleData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_NEW_BUILDER_RESALE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/builder-resale/add`,
        builderResaleData,
        config
      );

      dispatch({
        type: "ADD_NEW_BUILDER_RESALE_SUCCESS",
        payload: data,
      });

      return { statusCode: data.statusCode };
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error.message ||
        "Failed to add builder resale";

      dispatch({
        type: "ADD_NEW_BUILDER_RESALE_FAILED",
        payload: errorMessage,
      });

      throw error;
    }
  };
};

export const updateBuilderResale = (id, payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_BUILDER_RESALE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/builder-resale/update`,
        {
          builder_resale_id: id,
          ...payload,
        },
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "UPDATE_BUILDER_RESALE_SUCCESS",
          payload: data,
        });
        toast.success("Updated Successfully!!");
        return data;
      } else {
        dispatch({
          type: "UPDATE_BUILDER_RESALE_FAILED",
          payload: data,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_BUILDER_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};

export const changeBuilderResaleStatus = (builderResaleData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "CHANGE_BUILDER_RESALE_STATUS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/builder-resale/status-update`,
        builderResaleData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "CHANGE_BUILDER_RESALE_STATUS_SUCCESS",
          payload: data,
        });
        toast.success("Changed Successfully!!");
        return data;
      } else {
        dispatch({
          type: "CHANGE_BUILDER_RESALE_STATUS_FAILED",
          payload: data,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "CHANGE_BUILDER_RESALE_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};